// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseAllowedCaseStatusModels {
    static getAttributeTypeMap() {
        return CaseAllowedCaseStatusModels.attributeTypeMap;
    }
}
CaseAllowedCaseStatusModels.discriminator = undefined;
CaseAllowedCaseStatusModels.additionalProperties = false;
CaseAllowedCaseStatusModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=caseAllowedCaseStatusModels.js.map